import React from "react";
import { PortalHost } from "@gorhom/portal";
import { useIsFocused } from "@react-navigation/native";

interface FilterSplitScreenPortalHostProps {
  name: string;
}

const FilterSplitScreenPortalHost: React.FC<
  FilterSplitScreenPortalHostProps
> = ({ name }) => {
  const isFocused = useIsFocused();

  if (!isFocused) return null;

  return <PortalHost name={name} />;
};

export default FilterSplitScreenPortalHost;
